import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs/operators';
import { TiposContenido } from '../../models/tipos-contenido';
import { ExtraInfoCasillasCamposService } from '../../services/extra-info-casillas-campos.service';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { DatosTiposContenidoService } from '../../services/datos-tipos-contenido.service';

@Component({
  selector: 'app-configuracion-documento-incluir-contenido',
  templateUrl: './configuracion-documento-incluir-contenido.component.html',
  styleUrls: ['./configuracion-documento-incluir-contenido.component.css']
})
export class ConfiguracionDocumentoIncluirContenidoComponent implements OnInit {

  @Input() overlayMode = false;
  @Output() cerrar = new EventEmitter<void>();

  palabrasClave: TiposContenido[] = [];
  cargandoPalabras = false;
  top = 0;
  left = 0;
  palabraMover: TiposContenido;
  palabraMoverArray: TiposContenido[] = [];

  constructor(
    public formularioDocumentoService: FormularioDocumentoService,
    private extraInfoCasillasCamposService: ExtraInfoCasillasCamposService,
    private _snackBar: MatSnackBar,
    private datosTiposContenidoService: DatosTiposContenidoService
  ) {
    this.getTiposContenidoData();
  }

  ngOnInit(): void {
    this.formularioDocumentoService.formularioDocumento.get('incluirContenido')?.setValue(true);
  }

  solicitarCierre(): void {
    if (this.overlayMode && this.extraInfoCasillasCamposService.formularioPalabras?.invalid) {
      this._snackBar.open(
        'Hay errores en la información de tipo de contenido',
        'Cerrar',
        { duration: 3000 }
      );
      return;
    }
    this.cerrar.emit();
  }

  getTiposContenidoData(): void {
    this.cargandoPalabras = true;
    this.datosTiposContenidoService.getTiposContenido().pipe(
      finalize(() => {
        this.cargandoPalabras = false;
      })
    ).subscribe({
      next: (next) => {
        this.palabrasClave = next;
      },
      error: (error) => {
        if (error.status !== 401) {
          this._snackBar.open(error.message, 'Cerrar', { duration: 4000 });
        }
      }
    });
  }

  getPalabraAMover(event: { x: number; y: number; tipo: TiposContenido }): void {
    this.left = event.x;
    this.top = event.y;
    this.palabraMover = {
      nombre: event.tipo.nombre,
      id: event.tipo.id
    };
    this.palabraMoverArray.push(this.palabraMover);
    if (this.palabraMoverArray.length > 1) {
      this.palabraMoverArray.shift();
    }
  }
}
